import types from './types'

const updateFilters = (filters) => (dispatch) => {
  dispatch({
    type: types.UPDATE_FILTERS_START,
  })
  dispatch({
    type: types.UPDATE_FILTERS_SUCCESS,
    payload: filters,
  })
}

export default { updateFilters }
